import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Sticky banner shown to email/password users who haven't verified yet.
 * Google users skip this — they're always verified.
 */
const EmailVerificationBanner = ({ user }) => {
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);

  if (!user || user.email_verified || user.google_linked || user.role === 'admin' || dismissed) {
    return null;
  }

  const resend = async () => {
    setResending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, { email: user.email });
      toast.success('Verification email sent! Check your inbox.');
    } catch {
      toast.error('Failed to send. Please try again in a moment.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="w-full bg-amber-500/10 border-b border-amber-500/20 px-4 py-2.5 flex items-center justify-between gap-4 text-sm">
      <div className="flex items-center gap-2.5 min-w-0">
        <Mail className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <span className="text-amber-200 truncate">
          Please verify your email <strong className="text-white">{user.email}</strong> to unlock all features.
        </span>
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        <button
          onClick={resend}
          disabled={resending}
          className="text-amber-400 hover:text-amber-300 underline text-xs font-medium disabled:opacity-50 whitespace-nowrap"
        >
          {resending ? 'Sending…' : 'Resend link'}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-amber-500 hover:text-amber-300 transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
